module.exports = __webpack_public_path__ + "img/questionnaire-background.2c968a03.svg";